import React, { Component } from 'react';
import { translate } from "react-i18next";
import AlarmInfoList from './AlarmInfoList';
import { Button, Row, Col, Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { LANGUAGES, WARNING_THEMES } from '../../backend/Data';
import { getURL, sendJson, deleteItem } from '../../backend/Backend';


class AlarmInfoDetail extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveEvent = this.saveEvent.bind(this);
        this.loadById = this.loadById.bind(this);
        this.createNew = this.createNew.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        
        
        this.state = {
            warnings:[],
            event:{id:0,  title: '', description: '', link: '', startDate: new Date(), endDate: new Date(), active: true, cssClass: '', lang:'de' }
        };
    }

    async componentDidMount() {
        this.loadAll();
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { event } = this.state;

        const newEvent = {
            ...event,
            [fieldName]: fieldValue
        };
        this.setState({
            event: newEvent
        });
    }

    onEventStartDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            startDate: choosed !== null ? choosed.getTime() : '',
            endDate: choosed !== null ? choosed.getTime() : ''
        };

        this.setState({
            event: newEvent
        });
    }

    onEventEndDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            endDate: choosed !== null ? choosed.getTime() : ''
        };

        this.setState({
            event: newEvent
        });
    }


    handleChange(e) {

        const { event } = this.state;

        const newEvent = {
            ...event,
            [e.target.name]: e.target.checked
        };

        this.setState({
            event: newEvent
        });
    }

 
    async loadAll(){
        const response = await fetch(getURL(`infoEntity/loadAll`));
        const json = await response.json();
     
        let oldState = this.state;
    
        this.setState({
          ...oldState,
          warnings: json
        });
      }

      async loadById(id){
        const response = await fetch(getURL(`infoEntity/load/id/${id}`));
        const json = await response.json();
    
        let oldState = this.state;
    
        this.setState({
          ...oldState,
          event : json
        });
      }

      saveEvent(event) {
        sendJson('post', 'infoEntity', event).then(
            received => {
                console.log("Saved updateDetail: " + JSON.stringify(received));
    
               
               /* let oldState = this.state;
                this.setState({
                    ...oldState,
                    message: 'successSaved'
                });
                setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
                */
               this.loadAll();
            });
    }

    createNew(){
        let oldState = this.state;
    
        this.setState({
          ...oldState,
          event:{id:0,  title: '', description: '', link: '', startDate: new Date(), endDate: new Date(), active: true, cssClass: '', lang:'de' }
        });
    }

    deleteItem(id){
        deleteItem('infoEntity', id).then(
            received => {
              this.loadAll();
            });
    }
    


    render() {
        const { t } = this.props;
        const { event: {id,  title, description, link, startDate, endDate, active, lang, cssClass } } =  this.state;
        return (<div >
           
           <Row>
               <Col>
                  <AlarmInfoList warnings={this.state.warnings} loadById={this.loadById}/>
               </Col>
           </Row>
           <hr style={{ "border": "1px solid #DDDDDD", "border-radius": "1px" }} ></hr>
            
            <Row className={(cssClass ? "bg-" + cssClass : '') + " pb-2 pt-2"}>
                <Col>
                    <div>

                        <Row>
                            <Col>
                                <Form.Check label={t("active")} name="active" id="active" checked={active} onChange={this.handleChange} />
                            </Col>
                            <Col>
                                <Form inline>
                                    <Form.Group >
                                        <Form.Label htmlFor="lang" className="mr-2">{t("language")}</Form.Label>
                                        <Form.Control as="select" name="lang" value={lang} onChange={this.onEventInputChange} defaultValue="0">
                                            {LANGUAGES.map(c =>
                                                <option value={c} key={c} label={t(c)}></option>
                                            )}
                                        </Form.Control>

                                    </Form.Group>
                                </Form>
                            </Col>
                            <Col>
                                <Form inline>
                                    <Form.Group >
                                        <Form.Label htmlFor="cssClass" className="mr-2">{t("cssClass")}</Form.Label>
                                        <Form.Control as="select" name="cssClass" value={cssClass} onChange={this.onEventInputChange} className={"bg-" + cssClass}>
                                            {WARNING_THEMES.map(c =>
                                                <option value={c} key={c} label={t(c)} className={"bg-" + c}></option>
                                            )}
                                        </Form.Control>

                                    </Form.Group>
                                </Form>
                            </Col>


                        </Row>
                        <Row className="pt-3 " >
                            <Col lg={12} md={8}>
                                <Form.Control value={ title}
                                    name="title"
                                    onChange={this.onEventInputChange}
                                    placeholder={t("eventTitle")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={8}>
                                <Form.Control as="textarea" value={description}
                                    name="description" onChange={this.onEventInputChange}
                                    placeholder={t("eventDescription")} className="mt-2 "
                                    rows="5" />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={8}>
                                <Form.Control placeholder={"http://..."}
                                    value={link} name="link"
                                    onChange={this.onEventInputChange} className="mt-2" />
                            </Col>
                        </Row>
                        <Row className="pt-3 ">
                            <Col lg={12} md={8}>
                                <Row>
                                    <Col lg={1}>
                                        <Form.Label htmlFor="Startdatum">{t("eventStart")}</Form.Label>
                                    </Col>
                                    <Col lg={5}>
                                        <DatePicker selected={startDate}
                                            onChange={this.onEventStartDateChange}
                                            placeholderText={t("Startdatum")}
                                            minDate={new Date()}

                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            dateFormat="Pp"
                                            locale="de"
                                            className="form-control"
                                            name="Startdatum"

                                        />
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Label htmlFor="Enddatum">{t("eventEnd")}</Form.Label>
                                    </Col>
                                    <Col lg={5}>
                                        <DatePicker selected={endDate}
                                            onChange={this.onEventEndDateChange}
                                            placeholderText={t("Enddatum")}
                                            minDate={new Date()}

                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            dateFormat="Pp"
                                            locale="de"
                                            className="form-control"
                                            name="Enddatum"
                                        />
                                    </Col>
                                </Row>
                                <Row className="pt-3 ">
                                    <Col lg={12} md={8}>
                                        <Button variant="outline-primary" onClick={() => this.deleteItem(this.state.event.id)} className="float-left" disabled= {!this.state.event || !this.state.event.id ||  this.state.event.id === 0 }><span className="fa fa-trash-alt mr-2"></span>{t("loeschen")}</Button>

                                        <Button variant="outline-primary" onClick={() => this.saveEvent(this.state.event)} className="float-right"><span className="fa fa-save ml-2 mr-2"></span>{t("speichern")}</Button>
                                        <Button variant="outline-primary" onClick={() => this.createNew()} className="float-right mr-2"><span className="fa fa-plus ml-2 mr-2"></span>{t("create")}</Button>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>


                    </div>
                </Col>
            </Row>
        </div>)
    }

}

export default translate("translations")(AlarmInfoDetail);

